import { usePagination } from '@/srp/ResultsSection/hooks';
import GeoLocationButton from './GeoLocationButton';
import SaveSearch from './SaveSearch';
import { Bar } from './SearchTools.styles';
import SortBy from './SortBy';

export default function SearchTools() {
  const {
    pagination: { totalMatchedInventory = 0 }
  } = usePagination();

  return (
    <div
      id="search-tools"
      data-testid="srp-search-tools"
      className="my-2xl flex items-center justify-between sm:my-3xl"
    >
      <p className="text-text-weak t-body-sm" data-testid="results-count">
        {totalMatchedInventory.toLocaleString()} cars
      </p>
      <span className="flex items-center gap-lg">
        <GeoLocationButton />
        <Bar />
        <SortBy />
        <Bar />
        <SaveSearch />
      </span>
    </div>
  );
}
